export default __webpack_public_path__ + "static/media/areaBag.af8e1c62.png";